import { Component, EventEmitter, Output } from '@angular/core';
import { ClickOutsideDirective } from '../../../../shared/directives/click-outside/click-outside.directive';
@Component({
  selector: 'app-dropdown-container',
  templateUrl: './dropdown-container.component.html',
  styleUrls: ['./dropdown-container.component.scss'],
  imports: [ClickOutsideDirective],
})
export class DropdownContainerComponent {
  @Output() emitDropdownClose = new EventEmitter<void>();

  close() {
    this.emitDropdownClose.emit();
  }
}
